export default from './EditRecipe';


/** WEBPACK FOOTER **
 ** ./app/components/editRecipe/index.js
 **/